import React from "react";
import styles from "./main-banner.module.scss";
import mainBannerImg from "@/assets/main_banner.webp";
import { useTranslation } from "react-i18next";
import { Url } from "@/helpers/url";
import { FixButton } from "../fix-button";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";
import classNames from "classnames";
import { googleEvent } from "@/helpers/google-events.ts";

export type MainBannerProps = {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
};

export const MainBanner: React.FC<MainBannerProps> = ({ type = LayoutStyleTypes.TYPE_LG }) => {
  const { t } = useTranslation();
  // SSR: не используем window/document
  const { defaultLayoutStyleType } = useLayoutType();

  return (
    <div className={classNames(styles[defaultLayoutStyleType], styles.mainBanner)} style={{ backgroundImage: `url(${mainBannerImg})` }}>
      <div className={styles.fader}>
        <h2 className={styles.title}>{t("asdfjlcnsakdjhfv.are-you-business-title", "Are you a business?")}</h2>
        <div className={styles.subtitle}>
          {t("uio234hl234hjk2h.are-you-business-text", "Sign up for a business account and gain access to exclusive benefits and personal manager!")}
        </div>
        <div className={styles.bannerBtn}>
          <FixButton
            href={Url.to("signup-page")}
            variant="primary"
            type={"button"}
            size={"large"}
            className={classNames(styles.button)}
            onClick={() => googleEvent("start_business_account_click")}
          >
            {t("098dkjahsd89as9s.are-you-business-btn", "Let's Get Started!")}
          </FixButton>
        </div>
      </div>
    </div>
  );
};
